'use strict';

var React = require('react');

var SvgThemesMajor = function SvgThemesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1h-3.5v6h5v-4.5a1.5 1.5 0 0 0-1.5-1.5zm1.5 8h-5v10h3.5a1.5 1.5 0 0 0 1.5-1.5v-8.5zm-18 5h11v5h-9.5a1.5 1.5 0 0 1-1.5-1.5v-3.5zm1.5-13a1.5 1.5 0 0 0-1.5 1.5v9.5h11v-11h-9.5z"
  }));
};

exports.SvgThemesMajor = SvgThemesMajor;
